import { useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'motion/react';
import { transition, variants, headerVariants } from '../variants';
import { useBack } from '../../../utils/hooks/useBack';
import styles from './Header.module.css';

export default function Header({isGenerator = false, qrId = null, fromNewCollection = false}) {

    const navigate = useNavigate();
    const location = useLocation();
    const goBack = useBack();

    const handleNavigate = () => {
        navigate('/widgets', { state: { generator: true }})
    };

    const handleGeneratorBack = () => {
        // If we came from /collection/new (creating a new widget QR), go to details
        if (fromNewCollection && qrId) {
            navigate(`/collection/${qrId}/details?tab=details`);
            return;
        }

        // Check if we came from /collection details page
        const referrer = document.referrer;
        const detailsMatch = referrer?.match(/\/collection\/([^/]+)\/details/);
        const designMatch = referrer?.match(/\/collection\/([^/]+)\/design/);
        const newMatch = referrer?.match(/\/collection\/new/);
        
        if (detailsMatch) {
            // Go back to the details page we came from
            const qrIdFromReferrer = detailsMatch[1];
            navigate(`/collection/${qrIdFromReferrer}/details?tab=details`);
        } else if (designMatch) {
            // Came from design page, go to details for that QR
            const qrIdFromReferrer = designMatch[1];
            navigate(`/collection/${qrIdFromReferrer}/details?tab=details`);
        } else if (newMatch) {
            // Came from /collection/new, use the qrId prop if available
            if (qrId) {
                navigate(`/collection/${qrId}/details?tab=details`);
            } else {
                navigate('/collection');
            }
        } else if (referrer?.includes('/widgets')) {
            // Go back to widgets dashboard
            navigate('/widgets');
        } else if (qrId) {
            // Go to QR information page
            navigate(`/collection/${qrId}/details?tab=details`);
        } else {
            // QR ID doesn't exist, go to widgets dashboard
            navigate('/widgets');
        }
    };

    const handleCollectionBack = () => {
        navigate('/collection');
    };

    return (
        <div className={styles.container}>
            <AnimatePresence mode='wait'>
                <motion.button 
                    key='button' 
                    className={styles.backBtn} 
                    transition={transition}
                    variants={variants}
                    initial='initial'
                    animate='animate'
                    exit='initial'
                    onClick={isGenerator ? handleGeneratorBack : handleCollectionBack}
                >
                    <i className='far fa-arrow-left' />Back
                </motion.button>
            </AnimatePresence>
            <AnimatePresence mode='wait'>
                {isGenerator ? 
                    (<motion.h4
                        key='title-generator'
                        className={styles.title}
                        transition={transition}
                        variants={headerVariants}
                        initial='initial'
                        animate='animate'
                        exit='exit'
                    >
                        Widget Generator
                    </motion.h4>)
                    :
                    (<motion.h4
                        key='title'
                        className={styles.title}
                        transition={transition}
                        variants={headerVariants}
                        initial='initial'
                        animate='animate'
                        exit='exit'
                    >
                        Widgets
                    </motion.h4>)
                }
            </AnimatePresence>
            <AnimatePresence mode='wait'>
                {!isGenerator ? 
                    (<motion.button 
                        key='button' 
                        className={styles.navBtn} 
                        transition={transition}
                        variants={variants}
                        initial='initial'
                        animate='animate'
                        exit='initial'
                        onClick={handleNavigate}
                    >
                        Create New
                    </motion.button> )
                    :
                    (<motion.div 
                        key='no-button' 
                        className={styles.extraSpace}
                        transition={transition}
                        variants={variants}
                        initial='initial'
                        animate='animate'
                        exit='initial'
                    />)
                }
            </AnimatePresence>
        </div>
    );
};